<template>
    <div>
        <div v-if="loading">
            <loading/>
        </div>
        <div v-else>
            <div v-if="company.siret === '' || company.siret === null">
                <b-alert variant="warning" show class="mb-0">
                    Cette fonctionnalité n'est pas disponible car le SIREN n'est
                    pas renseigné
                </b-alert>
            </div>
            <div v-else :key="key" class="row">
                <div class="col-6">
                    <div class="row mt-3">
                        <b-col sm="10" offset="2">
                            <h4>Données enregistrées</h4>
                        </b-col>

                        <b-col sm="2">
                            <label class="mt-1">Nom</label>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="form.name"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                :class="border.name"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <label class="mt-1">Adresse</label>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="form.formatted_address"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                :class="border.formatted_address"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <label class="mt-1">Greffe</label>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="form.registration_city"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                :class="border.registration_city"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <label class="mt-1">Forme</label>
                        </b-col>
                        <b-col sm="10">
                            <b-form-select
                                v-model="form.legal_form_id"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                :class="border.legal_form_id"
                                :options="legalFormOptions"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <label class="mt-1">Capital</label>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="form.asset"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                :class="border.asset"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <label class="mt-1">Création</label>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="form.activity_start"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                :class="border.activity_start"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <label class="mt-1">Fin exercice</label>
                        </b-col>
                        <b-col sm="10">
                            <b-form-select
                                v-model="form.end_of_exercise"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                :class="border.end_of_exercise"
                                disabled
                                :options="endOfExerciseOptions"
                            />
                        </b-col>

                        <b-col sm="10" offset="2"></b-col>
                    </div>
                </div>
                <div class="col-6">
                    <div class="row mt-3">
                        <b-col sm="10" offset="2">
                            <h4>Données Pappers</h4>
                        </b-col>

                        <b-col sm="2">
                            <b-button
                                size="sm"
                                variant="primary"
                                block
                                title="Remplacer le nom"
                                @click="updateName"
                            >
                                <i class="fas fa-arrow-alt-left"></i>
                            </b-button>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="pappers.name"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <b-button
                                size="sm"
                                variant="primary"
                                block
                                block
                                title="Remplacer l'adresse'"
                                @click="updateAddress"
                            >
                                <i class="fas fa-arrow-alt-left"></i>
                            </b-button>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="pappers.address"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <b-button
                                size="sm"
                                variant="primary"
                                block
                                title="Remplacer le greffe"
                                @click="updateRegistrationCity"
                            >
                                <i class="fas fa-arrow-alt-left"></i>
                            </b-button>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="pappers.registration_city"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <b-button
                                size="sm"
                                variant="primary"
                                block
                                title="Remplacer la forme juridique"
                                @click="updateLegalForm"
                            >
                                <i class="fas fa-arrow-alt-left"></i>
                            </b-button>
                        </b-col>
                        <b-col sm="10">
                            <b-form-select
                                v-model="pappers.legal_form_id"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                disabled
                                :options="legalFormOptions"
                            />
                        </b-col>

                        <b-col sm="2">
                            <b-button
                                size="sm"
                                variant="primary"
                                block
                                title="Remplacer le capital"
                                @click="updateAsset"
                            >
                                <i class="fas fa-arrow-alt-left"></i>
                            </b-button>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="pappers.asset"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <b-button
                                size="sm"
                                variant="primary"
                                block
                                title="Remplacer la date de création"
                                @click="updateActivityStart"
                            >
                                <i class="fas fa-arrow-alt-left"></i>
                            </b-button>
                        </b-col>
                        <b-col sm="10">
                            <b-input
                                v-model="pappers.activity_start"
                                size="sm"
                                class="mb-1 bg-white text-dark"
                                disabled
                            />
                        </b-col>

                        <b-col sm="2">
                            <b-button
                                size="sm"
                                variant="primary"
                                block
                                title="Remplacer la fin d'exercice"
                                @click="updateEndOfExercise"
                            >
                                <i class="fas fa-arrow-alt-left"></i>
                            </b-button>
                        </b-col>
                        <b-col sm="10">
                            <b-form-select
                                v-model="pappers.end_of_exercise"
                                size="sm"
                                class="mb-2 bg-white text-dark"
                                disabled
                                :options="endOfExerciseOptions"
                            />
                            <span class="small">
                                <update-status-display
                                    :display-intro="true"
                                    :status="company.pappers_update_success"
                                    :update="company.pappers_updated_at"
                                />
                            </span>
                        </b-col>
                    </div>
                </div>

                <div class="col-12">
                    <b-alert
                        :show="formFeedback === 'progress'"
                        dismissible
                        variant="primary"
                        class="mt-3 mb-0"
                    >
                        Enregistrement en cours
                    </b-alert>
                    <b-alert
                        :show="formFeedback === 'done'"
                        dismissible
                        variant="success"
                        class="mt-3 mb-0"
                    >
                        Les données ont bien été enregistrées
                    </b-alert>
                    <b-alert
                        :show="formFeedback === 'error'"
                        dismissible
                        variant="danger"
                        class="mt-3 mb-0"
                    >
                        Une erreur s'est produite
                    </b-alert>
                </div>

                <div class="col-12">
                    <hr/>
                    <pappers-chiefs
                        :company="company"
                        @pappers-chiefs-is-updated="updateClientData"
                    />
                    <hr/>
                    <pappers-auditors
                        :company="company"
                        @pappers-auditors-is-updated="updateClientData"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

import PappersChiefs from './chiefs/PappersChiefs'
import PappersAuditors from './auditors/PappersAuditors'
import UpdateStatusDisplay from '../../legal/components/UpdateStatusDisplay'
import Loading from '../../../common/components/loading'

export default {
    name: 'PappersForm',

    components: {
        PappersChiefs,
        PappersAuditors,
        UpdateStatusDisplay,
        Loading,
    },

    props: {
        company: null,
        fullVue: null,
    },

    data() {
        return {
            form: {
                name: '',
                formatted_address: '',
                registration_city: '',
                asset: 0,
                legal_form_id: 0,
                activity_start: '',
                end_of_exercise: '',
            },
            border: {},
            pappers: {},
            formFeedback: null,
        }
    },

    async created() {
        this.$store.commit('browsing/START_LOADING')
        if (this.company.siret !== '' && this.company.siret !== null) {
            this.initForm()
        }
        this.$store.commit('browsing/STOP_LOADING')
    },

    methods: {
        initForm() {
            this.form.name = this.company.name
            this.form.formatted_address = this.company.formatted_address
            this.form.registration_city = this.company.registration_city
            this.form.asset = this.company.asset
            this.form.zip_code = this.company.zip_code
            this.form.city = this.company.city
            this.form.legal_form_id = this.company.legal_form_id
            this.form.activity_start = this.company.activity_start
            this.form.end_of_exercise = this.company.end_of_exercise

            if (this.company.pappers_data !== null && this.company.pappers_data !== undefined) {
                this.pappers.name = this.company.pappers_data.name
                this.pappers.address = this.company.pappers_data.address
                this.pappers.registration_city =
                    this.company.pappers_data.registration_city
                this.pappers.asset = this.company.pappers_data.asset
                this.pappers.zip_code = this.company.pappers_data.zip_code
                this.pappers.city = this.company.pappers_data.city
                this.pappers.legal_form_id =
                    this.company.pappers_data.legal_form_id
                this.pappers.activity_start =
                    this.company.pappers_data.activity_start
                this.pappers.end_of_exercise =
                    this.company.pappers_data.end_of_exercise
            }

            this.border.name =
                this.form.name === this.pappers.name
                    ? 'border-success'
                    : 'border-warning'
            this.border.formatted_address =
                this.form.formatted_address === this.pappers.address
                    ? 'border-success'
                    : 'border-warning'
            this.border.registration_city =
                this.form.registration_city === this.pappers.registration_city
                    ? 'border-success'
                    : 'border-warning'
            this.border.asset =
                parseFloat(this.form.asset) === parseFloat(this.pappers.asset)
                    ? 'border-success'
                    : 'border-warning'
            this.border.legal_form_id =
                this.form.legal_form_id === this.pappers.legal_form_id
                    ? 'border-success'
                    : 'border-warning'
            this.border.activity_start =
                this.form.activity_start === this.pappers.activity_start
                    ? 'border-success'
                    : 'border-warning'
            this.border.end_of_exercise =
                this.form.end_of_exercise === this.pappers.end_of_exercise
                    ? 'border-success'
                    : 'border-warning'
        },

        update() {
            if (this.fullVue) {
                this.$emit('update-company')
            } else {
                location.reload()
            }
        },

        updateName() {
            this.form.name = this.company.pappers_data.name
            this.updateClientData()
        },

        updateAddress() {
            this.form.formatted_address = this.company.pappers_data.address
            this.form.city = this.company.pappers_data.city
            this.form.zip_code = this.company.pappers_data.zip_code
            this.updateClientData()
        },

        updateRegistrationCity() {
            this.form.registration_city =
                this.company.pappers_data.registration_city
            this.updateClientData()
        },

        updateAsset() {
            this.form.asset = this.company.pappers_data.asset
            this.updateClientData()
        },

        updateLegalForm() {
            this.form.legal_form_id = this.company.pappers_data.legal_form_id
            this.updateClientData()
        },

        updateActivityStart() {
            this.form.activity_start = this.company.pappers_data.activity_start
            this.updateClientData()
        },

        updateEndOfExercise() {
            this.form.end_of_exercise =
                this.company.pappers_data.end_of_exercise
            this.updateClientData()
        },

        async updateClientData() {
            try {
                await axios.put(
                    `/clients/${this.company.id}/pappers`,
                    this.form
                )
                if (this.fullVue) {
                    this.$emit('company-has-been-updated')
                    this.initForm()
                } else {
                    location.reload()
                }
            } catch (error) {
                this.formFeedback = 'error'
                console.error(error)
            }
        },
    },

    computed: {
        ...mapState({
            loading: (state) => state.browsing.loading,
            key: (state) => state.browsing.key,
            legalFormOptions: (state) => state.data.options.legalForms,
            endOfExerciseOptions: (state) => state.data.options.endsOfExercise,
        }),

        submitIsDisabled() {
            return this.$v.$invalid
        },
    },
}
</script>

<style scoped></style>
